__webpack_require__.p = "/local/vue-investregion/dist/";